import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OptionGroup } from 'src/interfaces/option-group.interface';
import { Option } from 'src/interfaces/option.interface';
import { Product } from 'src/interfaces/product.interface';
import { Select } from '@ngxs/store';
import { GlobalStateModel } from '../../../../store/state.model';
import { Observable } from 'rxjs';
import { NavbarSettings } from '../../../../vendors/directus/interfaces/navbar-settings.interface';
import { ModeService } from '../../../../services/mode.service';
import { Upsells } from '../../../../interfaces/upsells.interface';
import { TextField } from '../../../../vendors/directus/interfaces/text-field.interface';
import { UpsellProduct } from '../../../../interfaces/upsell-product.interface';

@Component({
  selector: 'app-option-selector',
  templateUrl: './option-selector.component.html',
  styleUrls: ['./option-selector.component.scss'],
})
export class OptionSelectorComponent {
  @Select((state: GlobalStateModel) => state.app.navbarSettings) navbarSettings$: Observable<NavbarSettings>;
  @Select((state: GlobalStateModel) => state.order.upsells) upsells$: Observable<Upsells>;
  @Select((state: GlobalStateModel) => state.app.textField) textField$: Observable<TextField>;
  @Select((state: GlobalStateModel) => state.menu.recommendedDeals) recommendedDeals$: Observable<Product[]>;

  @Input() optionGroups: OptionGroup[];
  @Input() displayOptionGroups: OptionGroup[];
  @Input() isModifierFlow: boolean;
  @Input() isLoading: boolean;
  @Input() isModal: boolean;
  @Input() product: Product;
  @Input() currencyCode: string;
  @Output() clickedOption = new EventEmitter<{ option: Option; quantity: number }>();
  @Input() selectedOptions: Option[];

  optionSubGroup = null;

  constructor(protected mode: ModeService) {}

  optionClicked(event: { option: Option; quantity: number }) {
    this.clickedOption.emit(event);
  }

  getSelectedAmount(index: number) {
    const optiongroup = this.optionGroups[index];
    const opFilter = optiongroup.options.filter(op => op.isSelected);
    return opFilter.length;
  }

  optionGroupTrackBy(index: number, optionGroup: OptionGroup) {
    return `${optionGroup.optionGroupID}-${index}`;
  }

  upsellTrackByFn(index: number, item: UpsellProduct | Product) {
    return `${index}-${item.productID}`;
  }
}
